import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import TrackVisibility from 'react-on-screen';
import 'animate.css';
import colorSharp from "../assets/img/color-sharp.png"
import colorSharp2 from "../assets/img/color-sharp2.png"

// Import all your skill images here
import kotlin_img from "../assets/img/skills/kotlin_logo.png";
import java_img from "../assets/img/skills/java_logo.png";
import flutter_img from "../assets/img/skills/flutter.png"; // <<< ADD THIS IMAGE
import react_native_img from "../assets/img/skills/react.png"; // <<< ADD THIS IMAGE
import swift_img from "../assets/img/skills/swift.png"; // <<< ADD THIS IMAGE
import mvvm_img from "../assets/img/skills/mvvm_logo.png";
import room_img from "../assets/img/skills/room_logo.png";
import retrofit_img from "../assets/img/skills/retrofit_logo.png";
import coroutines_img from "../assets/img/skills/coroutines_logo.png";
import daggerhilt_img from "../assets/img/skills/room_logo.png";

import react_img from "../assets/img/skills/react.png"; // <<< ADD THIS IMAGE
import js_img from "../assets/img/skills/javascript.png"; // <<< ADD THIS IMAGE
import html_img from "../assets/img/skills/html.png"; // <<< ADD THIS IMAGE
import css_img from "../assets/img/skills/css.png"; // <<< ADD THIS IMAGE

import nodejs_img from "../assets/img/skills/nodejs_logo.png";
import firebase_img from "../assets/img/skills/firebase_logo.png";
import postgres_img from "../assets/img/skills/postgres_logo.png";
import aws_img from "../assets/img/skills/aws.png"; // <<< ADD THIS IMAGE
import gcp_img from "../assets/img/skills/gcp.png"; // <<< ADD THIS IMAGE
import spring_img from "../assets/img/skills/springboot.png"; // <<< ADD THIS IMAGE
import supabase_img from "../assets/img/skills/superbase.png"; // <<< ADD THIS IMAGE
import postman_img from "../assets/img/skills/postman.png"; // <<< ADD THIS IMAGE

import figma_img from "../assets/img/skills/figma.png"; // <<< ADD THIS IMAGE
import xd_img from "../assets/img/skills/xd_logo.png";
import canva_img from "../assets/img/skills/canva.png"; // <<< ADD THIS IMAGE
import github_img from "../assets/img/skills/github_logo.png";
import espresso_img from "../assets/img/skills/espresso_logo.png";


export const Skills = () => {
  // <<< Organized skills into categories
  const skillsData = {
    mobile: [
      { src: kotlin_img, name: "Kotlin" },
      { src: java_img, name: "Java" },
      { src: flutter_img, name: "Flutter" },
      // { src: react_native_img, name: "React" },
      { src: swift_img, name: "Swift IOS" },
      { src: mvvm_img, name: "MVVM/MVC" },
      // { src: room_img, name: "Room DB" },
      { src: retrofit_img, name: "Retrofit" },
      { src: coroutines_img, name: "Coroutines" },
      { src: daggerhilt_img, name: "Dagger Hilt" },
    ],
    web: [
      { src: react_img, name: "React.js" },
      { src: js_img, name: "JavaScript" },
      { src: html_img, name: "HTML5" },
      { src: css_img, name: "CSS3" },
    ],
    backend: [
      { src: nodejs_img, name: "Node.js" },
      { src: firebase_img, name: "Firebase" },
      { src: postgres_img, name: "PostgreSQL" },
      { src: aws_img, name: "AWS" },
      { src: gcp_img, name: "Google Cloud" },
      { src: spring_img, name: "Spring Boot" },
      { src: supabase_img, name: "Supabase" },
      { src: postman_img, name: "Postman" },
    ],
    tools: [
      { src: figma_img, name: "Figma" },
      { src: xd_img, name: "Adobe XD" },
      { src: canva_img, name: "Canva" },
      { src: github_img, name: "Git/GitHub" },
      { src: espresso_img, name: "Espresso" },
    ]
  };

  const renderSkillGrid = (skills) => (
    <div className="skill-grid">
      {skills.map((skill, index) => (
        <div key={index} className="skill-item">
          <div className="skill-icon-container">
            <img src={skill.src} alt={`${skill.name} logo`} />
          </div>
          <h5>{skill.name}</h5>
        </div>
      ))}
    </div>
  );

  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col xs={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={`skill-bx ${isVisible ? "animate__animated animate__zoomIn" : ""}`}>
                  <h2>My Skills</h2>
                  <p>As a Product Engineer, I use a diverse set of tools to bring ideas to life, from initial concept to final deployment.</p>

                  {/* <<< Replaced Carousel with a Tab component */}
                  <Tab.Container id="skills-tabs" defaultActiveKey="mobile">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="mobile">Mobile</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="web">Web & Frontend</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="backend">Backend & Cloud</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="tools">Design & Tools</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey="mobile">
                        {renderSkillGrid(skillsData.mobile)}
                      </Tab.Pane>
                      <Tab.Pane eventKey="web">
                        {renderSkillGrid(skillsData.web)}
                      </Tab.Pane>
                      <Tab.Pane eventKey="backend">
                        {renderSkillGrid(skillsData.backend)}
                      </Tab.Pane>
                      <Tab.Pane eventKey="tools">
                        {renderSkillGrid(skillsData.tools)}
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-left" src={colorSharp} alt="background" />
      <img className="background-image-right" src={colorSharp2} alt="background" />
    </section>
  )
}
